<form [formGroup]="form" autocomplete="off" (ngSubmit)="saveSaleTemplate()">
  <div class="media-category-names-popup">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">{{data?.template?.name}}<!--<i class="fa fa-spinner fa-spin" *ngIf="isLoader"></i>--></h4>
      <div class="d-flex justify-content-end ms-auto">
        <button type="button" class="btn col-auto me-2 btn-secondary" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-times"></i> Cancel</button>
        <button type="submit" class="btn col-auto btn-primary" [disabled]="!form.dirty || form.invalid"><i class="fa fa-save"></i> Save</button>
      </div>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-12 sticky">
          <div class="row">
            <div class="col-auto">
              <label>Template Name</label>
              <input formControlName="name" class="form-control" placeholder="Template Name" [ngClass]="{
            'border border-danger': form.controls['name'].errors
            && (form.controls['name'].invalid && (form.controls['name'].dirty || form.controls['name'].touched))
            }">
            </div>
            <div class="col-5">
              <label>Description</label>
              <input type="text" formControlName="description" class="form-control" placeholder="Description" />
            </div>
            <div class="col">
              <br />
              <app-search-box  placeholder="Search..." class="float-end w-75"
                              (searchChange)="applyFilter($event)">
              </app-search-box>
            </div>
          </div>
        </div>
        <div class="col-12">
          <app-media-category *ngIf="saleTemplate?.saleTemplateId" [topPositionPx]="110" (selectedIds)="getSelectedMediaIds($event)" [isUseInternalSearch]="false" [searchText]="searchText" [saleTemplateId]="data?.template?.saleTemplateId" [isSelectionMode]="true" [defaultSelectedMediaCategoryIds]="saleTemplate?.categoryIds">
          </app-media-category>
        </div>
      </div>
    </div>
  </div>
</form>
